import { render } from "./Days.vue?vue&type=template&id=2ac3ae4a&scoped=true"
import script from "./Days.vue?vue&type=script&lang=js"
export * from "./Days.vue?vue&type=script&lang=js"

import "./Days.vue?vue&type=style&index=0&id=2ac3ae4a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac3ae4a"]])

export default __exports__